import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { journalsQueries } from "@/entities/journal";
import { useLocalUser } from "@/shared/lib/hooks";

export const JournalBannerTitle = () => {
  const { titleId } = useParams();

  const { data: journalTitle } = useQuery(
    journalsQueries.getTitleJournal({ titleId: titleId || "" }),
  );

  const titleStatus = journalTitle?.mainJournal?.titleJournal?.status;
  const needsRevokedBannerData =
    titleStatus === "REJECTED" || titleStatus === "CANCELED";

  const { data: responsibleData } = useQuery({
    ...journalsQueries.getResponsibleCommentList(titleId || ""),
    enabled: !!titleId && needsRevokedBannerData,
  });

  const { data: signersData } = useQuery({
    ...journalsQueries.getJournalSignersList(titleId || ""),
    enabled: !!titleId && needsRevokedBannerData,
  });

  const localUser = useLocalUser();

  // Определяем: текущий пользователь — заполняющий данные (inputter) по титулу
  const currentUserIsInputter = useMemo(() => {
    return (
      responsibleData?.inputters?.some(
        (item: any) => item?.userHistory?.userId === localUser?.user_id,
      ) ?? false
    );
  }, [responsibleData, localUser?.user_id]);

  // Ролевые названия как в JournalsResponsibleTable
  const roleMapping: Record<string, string> = {
    inputters: "Заполнение данных",
    approvers: "Согласующий",
    signers: "Подписант",
    senders: "Отправка в ГСН",
  };

  // Находим ответственного, который отозвал титульный лист (есть комментарий), проверяем во всех ролях
  const revokerInfo = useMemo(() => {
    const candidates: Array<{ roleKey: keyof typeof roleMapping; item: any }>
      = [];
    const pushMatches = (roleKey: keyof typeof roleMapping, list?: any[]) => {
      (list || []).forEach((item: any) => {
        // Если есть комментарий (не null/undefined), считаем что кто-то отозвал ТЛ
        if (item?.comment != null) {
          candidates.push({ roleKey, item });
        }
      });
    };

    pushMatches("inputters", responsibleData?.inputters);
    pushMatches("approvers", responsibleData?.approvers);
    pushMatches("senders", responsibleData?.senders);
    // Some responses may not include signers; guard access
    pushMatches("signers" as any, (responsibleData as any)?.signers);

    return candidates[0] ?? null;
  }, [responsibleData]);

  let actionVerb = "отозвал";
  if (titleStatus === "REJECTED") actionVerb = "отклонил";
  else if (titleStatus === "CANCELED") actionVerb = "отозвал";

  // Rejected signer on title (first match)
  const rejectedSigner = useMemo(() => {
    const list = (signersData as any)?.signers || [];
    return list.find((s: any) => s?.status === "REJECTED") || null;
  }, [signersData]);

  // Показываем баннеры ТОЛЬКО при статусах REJECTED или CANCELED
  const isBannerStatus = titleStatus === "REJECTED" || titleStatus === "CANCELED";
  if (!isBannerStatus) {
    return null;
  }

  if (currentUserIsInputter && rejectedSigner) {
    const ui = rejectedSigner.userInfo || {};
    const fio = `${ui.userSurname || ui.surname || ""} ${
      ui.userFirstName || ui.firstName || ""
    } ${ui.userMiddleName || ui.middleName || ""}`
      .split("")
      .filter(Boolean)
      .join("")
      .trim();
    return (
      <div className="journal-banner">
        <div>
          Подписант {fio} отклонил титульный лист с замечанием. Просьба внести исправления
        </div>
        <div>
          {/* <Button onClick={() => setSearchParams({ status: "REJECTED" })}>
            Посмотреть замечания
          </Button> */}
        </div>
      </div>
    );
  }

  if (currentUserIsInputter && revokerInfo) {
    const user = revokerInfo.item?.userHistory || {};
    const fio = `${user.userSurname ?? ""} ${user.userFirstName ?? ""} ${
      user.userMiddleName ?? ""
    }`.trim();
    const roleName = roleMapping[revokerInfo.roleKey] || "";
    return (
      <div className="journal-banner">
        <div>
          {roleName} {fio} {actionVerb} титульный лист с замечанием. Просьба внести исправления
        </div>
        <div>
          {/* <Button onClick={() => setSearchParams({ status: "REJECTED" })}>
            Посмотреть замечания
          </Button> */}
        </div>
      </div>
    );
  }

  return null;
};


